import { useMutation, useQuery } from '@tanstack/react-query';

import collectiveApi from 'modules/common/collectiveApi';
import { useMember } from 'modules/common/queries/member';

interface ReferralPromptEligibility {
    eligible: boolean;
}

const fetchReferralPromptEligibility = async (memberId: number): Promise<ReferralPromptEligibility> => {
    const { data } = await collectiveApi.get(`/members/${memberId}/referral-prompt-eligibility/`);
    return data;
};

type PromptInteraction = 'engaged' | 'dismissed' | 'remind_later';

const postReferralPromptShown = async (memberId: number, action: PromptInteraction) => {
    const { data } = await collectiveApi.post(`/members/${memberId}/referral-prompt-eligibility/`, { action });
    return data;
};

export const useReferralPromptEligibility = (enabled: boolean) => {
    const { data: member } = useMember();
    const memberId = member?.id;

    return useQuery<ReferralPromptEligibility>({
        queryKey: ['referralPromptEligibility', memberId],
        queryFn: () => fetchReferralPromptEligibility(memberId!),
        enabled: enabled && !!memberId,
        staleTime: 5 * 60 * 1000,
    });
};

export const useReferralPromptShown = () => {
    const { data: member } = useMember();
    const memberId = member?.id;

    return useMutation({
        mutationFn: (action: PromptInteraction) => {
            if (!memberId) {
                return Promise.resolve();
            }
            return postReferralPromptShown(memberId, action);
        },
    });
};
